<template>
    <div v-if="status" class="swal2-container swal2-fade swal2-shown" style="overflow-y: auto;">
        <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show"
             tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
            <div class="swal2-header">
                <h2 class="swal2-title" id="swal2-title" style="display: flex;">{{ $t('messages.registationmodal.title') }}</h2>
                <button type="button" class="swal2-close" @click="status=false">×</button>
            </div>
            <div class="swal2-content">
                <label class="control-label">{{ $t("messages.registationmodal.text") }}</label>

                <br/><br/>
                <div class="input-group">
                    <input v-model="password" class="form-control" type="text"/>

                    <span class="input-group-btn">
                        <button class="btn btn-copy btn-success" type="button" v-clipboard="password">{{ $t('messages.registationmodal.copy') }}</button>
                    </span>
                </div>
            </div>

            <div class="swal2-actions" style="display: flex;">
                <button type="button" @click="status=false" class="swal2-cancel swal2-styled"
                        style="display: inline-block; background-color: rgb(170, 170, 170);" aria-label="">{{ $t('messages.registationmodal.cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RegistrationModal',
        data: function () {
            return {
                status: false,
                password: '',
            }
        },
    }
</script>

<style scoped>

</style>